import { ProfileState } from '../objects/profileState';
import { ProfileActionTypes, SET_LOGIN, SET_PERMISSIONS, SET_PREFERENCES, SET_PROFILE, SET_TOKEN_EXPIRES_AT } from './actionTypes';

const initialState: ProfileState = {
    id: localStorage.getItem('user_id') !== null ? parseInt(<string>localStorage.getItem('user_id')) : null,
    permissions: null,
    preferences: null,
    profile: null,
    retrieved: false,
    token: localStorage.getItem('token'),
    token_expires_at: localStorage.getItem('token_expires_at')
};

export default (state = initialState, action: ProfileActionTypes): ProfileState => {
    switch (action.type) {
        case SET_PROFILE: {
            return {...state, retrieved: !!state.permissions && !!state.preferences, profile: action.payload};
        }
        case SET_PERMISSIONS: {
            return {...state, retrieved: !!state.profile && !!state.preferences, permissions: action.payload};
        }
        case SET_PREFERENCES: {
            return {...state, retrieved: !!state.permissions && !!state.profile, preferences: action.payload};
        }
        case SET_LOGIN: {
            const { token_expires_at, token, user, permissions } = action.payload;
            return {
                ...state,
                id: user.id,
                permissions: permissions,
                profile: user,
                retrieved: true,
                token: token,
                token_expires_at: token_expires_at
            };
        }
        case SET_TOKEN_EXPIRES_AT: {
            if (action.payload) {
                localStorage.setItem('token_expires_at', action.payload);
            } else {
                localStorage.removeItem('token_expires_at');
            }
            return { ...state, token_expires_at: action.payload };
        }
        default:
            return state;
    }
};